var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBigNeedle2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 64,
    viewBox: "0 0 19 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 54.5,
    r: 9.5,
    fill: "#235592"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 0L18 50H1L9.5 0Z",
    fill: "#235592"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigNeedle2);
export default __webpack_public_path__ + "static/media/big-needle2.08de7b12453d3e359955f3f7c6e3e885.svg";
export { ForwardRef as ReactComponent };